import React, { useEffect, useState } from "react"
import LoginLogoutForm from "./LoginLogoutForm"
import LanguageSwapButton from "./LanguageSwapButton"
import OfficialSiteButton from "./OfficialSiteButton"
import MyPageButton from "./MyPageButton"
import { connect } from "react-redux"

function Header(props) {
  const [logoImagePath, setlogoImagePath] = useState([]);
  const [officialUrl, setOfficialUrl] = useState([]);
  const [facebookUrl, setFacebookUrl] = useState('');
  const [twitterUrl, setTwitterUrl] = useState('');

  useEffect(() => {
		//ロゴのパスをセット
		//logoImagePath[0]:ja_header_file, logoImagePath[1]:en_header_file , logoImagePath[2]:main_header_file
    getLogoImg();
    if (props.customize) {
      setOfficialUrl(props.customize.official_url);
      setFacebookUrl(props.customize.facebook_url);
      setTwitterUrl(props.customize.twitter_url);
    }
  }, [props.customize]);

	const getLogoImg = () => {
		setlogoImagePath( (prevState) => ([ ...prevState, '/assets/img/common/logo-ja.png' ]) )
		setlogoImagePath( (prevState) => ([ ...prevState, '/assets/img/common/logo-en.png' ]) )
		setlogoImagePath( (prevState) => ([ ...prevState, '/assets/img/common/logo-main.png' ]) )
	}

  return (
    <header className="global-header">
      <div className="global-header__inner">
        <div className="global-header__logo">
          <a href="/" title="">
          { (props.language === 'ja_JP') ?
              <img src={logoImagePath[0]} />
            : 
              <img src={logoImagePath[1]}/>
          }
          </a>
        </div>
        <nav className="global-header-navi">
          <div className="global-header-navi__pc">
            <LanguageSwapButton language={props.language} />
            <OfficialSiteButton language={props.language} officialUrl={officialUrl} facebookUrl={facebookUrl} twitterUrl={twitterUrl} />
            <MyPageButton isLoggedIn={props.loggedIn} language={props.language} />
            <LoginLogoutForm
              isLoggedIn={props.loggedIn}
              language={props.language}
              isSp={false}
            />
            <LoginLogoutForm
              isLoggedIn={props.loggedIn}
              language={props.language}
              isSp={true}
            />
          </div>
        </nav>
      </div>
    </header>
  )
}

const mapStateToProps = (state) => {
  return {
    language: state.piano.language,
    loggedIn: state.piano.loggedIn,
    customize: state.customize.customize,
  }
}

export default connect(mapStateToProps)(Header)
